import ItemFilter, { type FilterOption } from './ItemFilter';

export type ModeFilterValue =
  | 'velocity'
  | 'planningAccuracy'
  | 'pointsPerPerson';

export default class ModeFilter extends ItemFilter<ModeFilterValue> {
  constructor({
    initialItems = ['velocity'],
  }: { initialItems?: ModeFilterValue[] } = {}) {
    const initialOptions = ModeFilter.initOptions();
    super(initialItems, initialOptions);
  }

  static initOptions(): FilterOption<ModeFilterValue>[] {
    return [
      { text: 'Velocity', value: 'velocity', label: 'Velocity' },
      {
        text: 'Planning accuracy',
        value: 'planningAccuracy',
        label: 'Planning accuracy',
      },
      {
        text: 'Points per person',
        value: 'pointsPerPerson',
        label: 'Points per person',
      },
    ];
  }
}
